import { useState } from 'react';
import DragAndDrop from '../../../UI/DragAndDrop';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import { urls } from '../api/urls';
import { useTranslation } from 'react-i18next';
import useHttp from '../../../../hooks/use-http';
import { convertBase64ToFile } from '../../../../../utils/convertBase64ToFile';
import { downloadFile } from '../../../../../utils/downloadFile';

const Attachments = ({ setAttachmentData, attachmentData }) => {
  console.log('attachmentData', attachmentData);
  const { t, i18n } = useTranslation();
  const { getData } = useHttp('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [fileForDelete, setFileForDelete] = useState();
  const handleFiles = (files) => {
    console.log(files);
    setAttachmentData(files);
  };

  const handleDownloadFile = async (item) => {
    const config = {
      method: 'POST',
      url: urls.DOWNLOAD_DOKUMENT,
      data: { id: item.id },
    };
    const result = await getData(config);
    if (result) {
      const file = convertBase64ToFile(result, item.name, item.type);
      downloadFile(file);
    }
  };

  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: { id: fileForDelete.id },
    };
    const result = await getData(config);
    if (result) {
      const newFileList = attachmentData.filter((item) => {
        return item.id !== fileForDelete.id;
      });
      setOpenDeleteDialog(false);
      setAttachmentData(newFileList);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleRemoveFile = (file) => {
    setFileForDelete(file);
    // const newFileList = attachmentData.filter((item) => {
    //   return item.id !== file.id;
    // });
    // setAttachmentData(newFileList);
    setOpenDeleteDialog(true);
  };
  return (
    <div>
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={100}
        addedFiles={attachmentData}
        handleRemoveFile={handleRemoveFile}
        customDownload={handleDownloadFile}
        enableCustomDownload
        enableDelete={false}
        enableAddFiles={false}
        showPreview
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Attachments;
